
$(function() {
  $('a[data-modal]').on('click', function() {
    $($(this).data('modal')).modal();
    return false;
  });
});

$(function() {
  $(".open-tfi-extra-info").click(function(e){
    e.preventDefault();
    $(this).parents('p').next(".tfi-extra-info").toggle();
    if($(this).parents('p').next(".tfi-extra-info").is(':visible')) {
      $(this).find('.open-tfi-extra-info-view').hide();
      $(this).find('.open-tfi-extra-info-close').show();
    }
    else {
      $(this).find('.open-tfi-extra-info-close').hide();
      $(this).find('.open-tfi-extra-info-view').show();
    }
  });
});

$(function() {
 $('.js-qty .js-qty__adjust').on('click', function(){
   var qty = parseInt($(this).parent('.js-qty').find('.quantity__input').val());
   if($(this).hasClass('quantity__plus')) {
     qty++;
   }else {
     if(qty > 1) {
       qty--;
     }
   }
   qty = (isNaN(qty))?1:qty;
   $(this).parent('.js-qty').find('.quantity__input').val(qty);
 }); 
});


$(function() {
 $('.cart-popup__dismiss-button').on('click', function(){
   
   var current_tfi_collection_id = $('.product-template__container').attr('data-tfi-collection-id');
   
   
   var next_tfi_collection = tfi_custom_box_next_step(current_tfi_collection_id);
   var next_tfi_collection_url = next_tfi_collection.next_tfi_collection_url;
   var tfi_custom_box_step_first = next_tfi_collection.tfi_custom_box_step_first;
   var tfi_custom_box_step_last = next_tfi_collection.tfi_custom_box_step_last;
   
   if (next_tfi_collection_url) {
     //window.location.pathname = next_tfi_collection_url;
     window.location = next_tfi_collection_url;
   }
 }); 
});


$(function() {
  
  var current_tfi_collection_id = $('.product-template__container').attr('data-tfi-collection-id');
  var next_tfi_collection = tfi_custom_box_next_step(current_tfi_collection_id);
  var current_tfi_custom_box_step = next_tfi_collection.current_tfi_custom_box_step;
  var next_tfi_collection_url = next_tfi_collection.next_tfi_collection_url;
  var tfi_custom_box_step_first = next_tfi_collection.tfi_custom_box_step_first;
  var tfi_custom_box_step_last = next_tfi_collection.tfi_custom_box_step_last;
  

  if(current_tfi_custom_box_step) {
    var fill_box_step = current_tfi_custom_box_step;

    document.getElementById("tfi-custom-box-steps").style.display="block";
	
    
    for (i = 1; i <= fill_box_step; i++) {
      document.getElementById("box_step_"+i).classList.add("tfi-step-done");
    }
    for (i = fill_box_step; i > fill_box_step && i <= 20; i++) {
      document.getElementById("box_step_"+i).classList.add("tfi-step-pending");
    }
    document.getElementById("box_step_"+fill_box_step).classList.add("tfi-step-active");
  }
});

function tfi_custom_box_next_step(current_tfi_collection_id) {
  
  
  var prev_tfi_collection_url = null;
  var next_tfi_collection_id = null;
  var next_tfi_collection_url = null;
  var current_tfi_custom_box_step = null;
  var tfi_custom_box_step_first = false;
  var tfi_custom_box_step_last = false;
  if (typeof current_tfi_collection_id === 'undefined' || current_tfi_collection_id == null) {
    //
  }
  else if(current_tfi_collection_id == '156050587717') { //Beef moves on to Lamb
    tfi_custom_box_step_first = true;
    current_tfi_custom_box_step = 1; //Beef
    prev_tfi_collection_url = null;
    next_tfi_collection_id = 156050915397; //Lamb
    next_tfi_collection_url = "/collections/lamb?fill-box-step=2"; //Lamb          
  }
  else if(current_tfi_collection_id == '156050915397') { //Lamb moves on to Chicken
    current_tfi_custom_box_step = 2; //Lamb
    prev_tfi_collection_url = "/collections/beef?fill-box-step=1"; //Beef
    next_tfi_collection_id = 156050849861; //Chicken
    next_tfi_collection_url = "/collections/chicken?fill-box-step=3";
  }
  else if(current_tfi_collection_id == '156050849861') { //Chicken moves on to Pork
    current_tfi_custom_box_step = 3; //Chicken
    prev_tfi_collection_url = "/collections/lamb?fill-box-step=2"; //Lamb
    next_tfi_collection_id = 156050948165; //Pork
    next_tfi_collection_url = "/collections/pork-1?fill-box-step=4";
  }
  else if(current_tfi_collection_id == '156050948165') { //Pork on to Seafood
    current_tfi_custom_box_step = 4; //Pork
    prev_tfi_collection_url = "/collections/chicken?fill-box-step=3"; //Chicken
    next_tfi_collection_id = 156093481029; //Seafood
    next_tfi_collection_url = "/collections/our-seafood?fill-box-step=5";
  }else if(current_tfi_collection_id == '156093481029') { //Seafood on to Fresh Produce
    current_tfi_custom_box_step = 5; //Seafood
    prev_tfi_collection_url = "/collections/pork-1?fill-box-step=4"; //Porknext_tfi_collection_id = 156049178693; //Pantry
    next_tfi_collection_url = "/collections/pantry?fill-box-step=7";
  }else if(current_tfi_collection_id == '156049178693') { //Pantry moves on to cart/checkout
    tfi_custom_box_step_last = true;
    current_tfi_custom_box_step = 6; //Pantryprev_tfi_collection_url = "/collections/our-seafood?fill-box-step=5"; //Seafood
    next_tfi_collection_id = null;
    next_tfi_collection_url = "/cart?fill-box-step=20";
  }
  else {
    prev_tfi_collection_url = "/collections/pantry?fill-box-step=7"; //Pantry
    next_tfi_collection_id = 0;
    next_tfi_collection_url = null;
  }
  

  return {current_tfi_custom_box_step: current_tfi_custom_box_step, prev_tfi_collection_url: prev_tfi_collection_url, next_tfi_collection_url: next_tfi_collection_url, tfi_custom_box_step_first: tfi_custom_box_step_first, tfi_custom_box_step_last: tfi_custom_box_step_last};
}

if(fill_box_step) {
  
  document.getElementById("tfi-custom-box-footer-steps").style.display="block";
  
  if(pathway && pathway == 'pre-made-box') {
    document.getElementById("tfi-cbfs-btn-shortcut-checkout").style.display="block";
    document.getElementById("tfi-custom-box-footer-steps").classList.add("shortcut-checkout-displayed");
  }

  var next_tfi_collection = tfi_custom_box_next_step(current_tfi_collection_id);
  var prev_tfi_collection_url = next_tfi_collection.prev_tfi_collection_url;
  var next_tfi_collection_url = next_tfi_collection.next_tfi_collection_url;
  var tfi_custom_box_step_first = next_tfi_collection.tfi_custom_box_step_first;
  var tfi_custom_box_step_last = next_tfi_collection.tfi_custom_box_step_last;
  
  if (checkout_shortcut) {
    document.getElementById("tfi-custom-box-footer-steps").style.display="none";
    document.getElementById("tfi-cbfs-btn-next-step").style.display = "none";
    document.getElementById("tfi-cbfs-btn-prev-step").style.display = "none";
  }
  else if (next_tfi_collection_url) {
    //$('#tfi-custom-box-footer-steps').find('.tfi-btn-next-step').attr("href", next_tfi_collection_url);
    document.getElementById("tfi-cbfs-btn-next-step").href=next_tfi_collection_url;
    if(tfi_custom_box_step_last) {
      document.getElementById("tfi-cbfs-btn-next-step").innerHTML='Checkout &#155;';
    }
    else {
      document.getElementById("tfi-cbfs-btn-next-step").innerHTML='Next step &#155;';
    }
    if (prev_tfi_collection_url) {
      document.getElementById("tfi-cbfs-btn-prev-step").href=prev_tfi_collection_url;
    }
    else {
      document.getElementById("tfi-cbfs-btn-prev-step").style.display = "none";
    }
  }
  else if (prev_tfi_collection_url) {
    document.getElementById("tfi-cbfs-btn-prev-step").href=prev_tfi_collection_url;
  }
  else {
    document.getElementById("tfi-custom-box-footer-steps").style.display="none";
    document.getElementById("tfi-cbfs-btn-next-step").style.display = "none";
    document.getElementById("tfi-cbfs-btn-prev-step").style.display = "none";
  }

  
}
else {
  document.getElementById("tfi-custom-box-footer-steps").style.display="none";
}$(function() {
  
  var initial_product_url = $('.tfi-choose-your-box-products-list.tfi-choose-option-list .tfi-fancy-option-container-selected').data('href');
  $('#tfi-choose-your-box-products-cta').attr('href', initial_product_url);
  
  
  $('.tfi-choose-your-box-products-list.tfi-choose-option-list .tfi-fancy-option-input').change(function(){
    $('.tfi-fancy-option-container').removeClass('tfi-fancy-option-container-selected');
    $(this).parents('.tfi-fancy-option-container').addClass('tfi-fancy-option-container-selected');
    var selected_product_url = $(this).parents('.tfi-fancy-option-container').data('href');
    $('#tfi-choose-your-box-products-cta').attr('href', selected_product_url);
    
    
    $('#tfi-choose-your-box-products-cta')[0].click();
  }); 
});

$(function() {
  $('.tfi-variants-selector.tfi-choose-option-list .tfi-fancy-option-input').change(function(){
    $('.tfi-fancy-option-container').removeClass('tfi-fancy-option-container-selected');
    $(this).parents('.tfi-fancy-option-container').addClass('tfi-fancy-option-container-selected');
  }); 
});

$(function() {
 $('.tfi-choose-your-box_item-modal .tfi-product-info-modal-cta').click(function(){
   var product_id = $(this).parents('.tfi-product-info-modal').data('product-id');
   var selected_product_url = $(this).parents('.tfi-product-info-modal').data('product-href');
   $.modal.close();
   $('#tfi-choose-your-box-products-cta').attr('href', selected_product_url);
   $('#tfi-choose-your-box-products-cta')[0].click();
 }); 
});


function tfi_resize_carousel_item_heights(reset_item_heights) {
  if( !$('.tfi-collection-carousel').hasClass('apply-equal-heights') ) {
    return;
  }
  
  reset_item_heights = reset_item_heights || false;
  
  if(reset_item_heights) {
    $('.tfi-collection-carousel .grid__item').css("height", "");
  }
  
  // Select and loop the container element of the elements you want to equalise
  $('.tfi-collection-carousel').each(function(){

    // Cache the highest
    var highestBox = 0;

    // Select and loop the elements you want to equalise
    $('.grid__item', this).each(function(){

      // If this box is higher than the cached highest then store it
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }

    });  

    // Set the height of all those children to whichever was highest 
    $('.grid__item' ,this).height(highestBox);

  }); 
}

$(document).ready(function(){
  tfi_resize_carousel_item_heights();
});
  
$(window).on('load', function(){
  tfi_resize_carousel_item_heights(true);
});

$(window).on('resize', function(){
  tfi_resize_carousel_item_heights(true);
});


function tfi_resize_product_range_heading_heights(reset_item_heights) {
  reset_item_heights = reset_item_heights || false;
  
  if(reset_item_heights) {
    $('.tfi-product-range-carousel.tfi-collection-carousel .tfi-product-range-carousel__title').css("height", "");
  }
  
  // Select and loop the container element of the elements you want to equalise
  $('.tfi-product-range-carousel.tfi-collection-carousel').each(function(){

    // Cache the highest
    var highestHeading = 0;

    // Select and loop the elements you want to equalise
    $('.tfi-product-range-carousel__title', this).each(function(){

      // If this box is higher than the cached highest then store it
      if($(this).height() > highestHeading) {
        highestHeading = $(this).height(); 
      }

    });  

    // Set the height of all those children to whichever was highest 
    $('.tfi-product-range-carousel__title', this).height(highestHeading);

  }); 
}

$(document).ready(function(){
  tfi_resize_product_range_heading_heights();
});
  
$(window).on('load', function(){
  tfi_resize_product_range_heading_heights(true);
});

$(window).on('resize', function(){
  tfi_resize_product_range_heading_heights(true);
});


$(document).ready(function(){
    $('p').filter(function () { return this.innerHTML == "" }).remove();
    $('p').filter(function () { return this.innerHTML == "<br>" }).remove();
    $('p').filter(function () { return this.innerHTML == "<br/>" }).remove();
});


